import React from 'react';
import { Button, ControlLabel, FormControl, FormGroup, Modal } from 'react-bootstrap';

export default ({
  jobs,
  onConfirm,
  onHide,
  onWorkOrderTemplateChange,
  show,
  templates,
  workOrderTemplateId
}) => (
  <Modal bsSize="small" onHide={onHide} show={show}>
    <Modal.Header>
      <Modal.Title>Print Work Order</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      {templates.length > 1 && (
        <FormGroup>
          <ControlLabel>Work Order Template</ControlLabel>
          <FormControl
            componentClass="select"
            onChange={e => onWorkOrderTemplateChange((e.target.value))}
            value={workOrderTemplateId || ''}
          >
            {templates.map(t => <option key={t.uniqueId} value={t.uniqueId}>{t.name}</option>)}
          </FormControl>
        </FormGroup>
      )}
    </Modal.Body>
    <Modal.Footer>
      <Button bsStyle="default" onClick={onHide}>
        Cancel
      </Button>
      <Button bsStyle="primary" onClick={() => onConfirm()}>
        Print
      </Button>
    </Modal.Footer>
  </Modal>
);
